import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import { company, mainNav, services } from '../../data/site';
import { EASE_IN_OUT, EASE_OUT } from '../../lib/motion';
import StatusClock from './StatusClock';
import ThemeToggle from './ThemeToggle';

const item = {
  hidden: { y: '110%' },
  show: i => ({ y: '0%', transition: { duration: 0.8, ease: EASE_OUT, delay: 0.18 + i * 0.05 } })
};

// Full-screen menu for small screens: big stacked links that rise out of masks
const MobileMenu = ({ open, onNavigate }) => {
  const links = [
    { path: '/', label: 'Home' },
    ...services.map(s => ({ path: s.path, label: s.name, index: s.index })),
    ...mainNav
  ];

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          id="mobile-menu"
          className="fixed inset-0 z-40 flex flex-col bg-background px-[var(--gutter)] pb-8 pt-[calc(var(--header-h)+1.5rem)] lg:hidden"
          initial={{ clipPath: 'inset(0 0 100% 0)' }}
          animate={{ clipPath: 'inset(0 0 0% 0)', transition: { duration: 0.7, ease: EASE_IN_OUT } }}
          exit={{ clipPath: 'inset(0 0 100% 0)', transition: { duration: 0.55, ease: EASE_IN_OUT } }}
          data-lenis-prevent
        >
          <nav aria-label="Mobile" className="flex-1 overflow-y-auto">
            <motion.ul initial="hidden" animate="show" className="space-y-1">
              {links.map((link, i) => (
                <li key={link.path} className="overflow-hidden">
                  <motion.div variants={item} custom={i}>
                    <NavLink
                      to={link.path}
                      end={link.path === '/'}
                      onClick={onNavigate}
                      className={({ isActive }) =>
                        `flex items-baseline gap-3 py-1 text-[2.25rem] font-medium leading-tight tracking-[-0.04em] [font-stretch:112%] ${isActive ? 'text-brand-ink' : 'text-foreground'}`
                      }
                    >
                      {link.index && <span className="label">({link.index})</span>}
                      {link.label}
                    </NavLink>
                  </motion.div>
                </li>
              ))}
            </motion.ul>
          </nav>

          <motion.div
            className="mt-8 flex items-end justify-between gap-6 border-t border-border pt-6"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0, transition: { delay: 0.5, duration: 0.6, ease: EASE_OUT } }}
          >
            <div className="space-y-2">
              <StatusClock />
              <a href={`mailto:${company.email}`} className="block text-sm text-muted-foreground">{company.email}</a>
              <Link to="/contact" onClick={onNavigate} className="block text-sm font-medium text-foreground">Book a consultation →</Link>
            </div>
            <ThemeToggle />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;
